'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import usePreviousProps from '@mui/utils/usePreviousProps';
import composeClasses from '@mui/utils/composeClasses';
import useSlotProps from '@mui/utils/useSlotProps';
import useBadge from "./useBadge.js";
import { styled } from "../zero-styled/index.js";
import memoTheme from "../utils/memoTheme.js";
import createSimplePaletteValueFilter from "../utils/createSimplePaletteValueFilter.js";
import { useDefaultProps } from "../DefaultPropsProvider/index.js";
import capitalize from "../utils/capitalize.js";
import badgeClasses, { getBadgeUtilityClass } from "./badgeClasses.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var RADIUS_STANDARD = 10;
var RADIUS_DOT = 4;
var useUtilityClasses = function(ownerState) {
    var color = ownerState.color, anchorOrigin = ownerState.anchorOrigin, invisible = ownerState.invisible, overlap = ownerState.overlap, variant = ownerState.variant, _ownerState_classes = ownerState.classes, classes = _ownerState_classes === void 0 ? {} : _ownerState_classes;
    var slots = {
        root: [
            'root'
        ],
        badge: [
            'badge',
            variant,
            invisible && 'invisible',
            "anchorOrigin".concat(capitalize(anchorOrigin.vertical)).concat(capitalize(anchorOrigin.horizontal)),
            "anchorOrigin".concat(capitalize(anchorOrigin.vertical)).concat(capitalize(anchorOrigin.horizontal)).concat(capitalize(overlap)),
            "overlap".concat(capitalize(overlap)),
            color !== 'default' && "color".concat(capitalize(color))
        ]
    };
    return composeClasses(slots, getBadgeUtilityClass, classes);
};
var BadgeRoot = styled('span', {
    name: 'MuiBadge',
    slot: 'Root',
    overridesResolver: function(props, styles) {
        return styles.root;
    }
})({
    position: 'relative',
    display: 'inline-flex',
    // For correct alignment with the text.
    verticalAlign: 'middle',
    flexShrink: 0
});
var BadgeBadge = styled('span', {
    name: 'MuiBadge',
    slot: 'Badge',
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.badge,
            styles[ownerState.variant],
            styles["anchorOrigin".concat(capitalize(ownerState.anchorOrigin.vertical)).concat(capitalize(ownerState.anchorOrigin.horizontal)).concat(capitalize(ownerState.overlap))],
            ownerState.color !== 'default' && styles["color".concat(capitalize(ownerState.color))],
            ownerState.invisible && styles.invisible
        ];
    }
})(memoTheme(function(param) {
    var theme = param.theme;
    return {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        boxSizing: 'border-box',
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(12),
        minWidth: RADIUS_STANDARD * 2,
        lineHeight: 1,
        padding: '0 6px',
        height: RADIUS_STANDARD * 2,
        borderRadius: RADIUS_STANDARD,
        zIndex: 1,
        // Render the badge on top of potential ripples.
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        variants: _to_consumable_array(Object.entries(theme.palette).filter(createSimplePaletteValueFilter([
            'contrastText'
        ])).map(function(param) {
            var _param = _sliced_to_array(param, 1), color = _param[0];
            return {
                props: {
                    color: color
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette[color].main,
                    color: (theme.vars || theme).palette[color].contrastText
                }
            };
        })).concat([
            {
                props: {
                    variant: 'dot'
                },
                style: {
                    borderRadius: RADIUS_DOT,
                    height: RADIUS_DOT * 2,
                    minWidth: RADIUS_DOT * 2,
                    padding: 0
                }
            },
            {
                props: function(param) {
                    var ownerState = param.ownerState;
                    return ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'rectangular';
                },
                style: _define_property({
                    top: 0,
                    right: 0,
                    transform: 'scale(1) translate(50%, -50%)',
                    transformOrigin: '100% 0%'
                }, "&.".concat(badgeClasses.invisible), {
                    transform: 'scale(0) translate(50%, -50%)'
                })
            },
            {
                props: function(param) {
                    var ownerState = param.ownerState;
                    return ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'rectangular';
                },
                style: _define_property({
                    bottom: 0,
                    right: 0,
                    transform: 'scale(1) translate(50%, 50%)',
                    transformOrigin: '100% 100%'
                }, "&.".concat(badgeClasses.invisible), {
                    transform: 'scale(0) translate(50%, 50%)'
                })
            },
            {
                props: function(param) {
                    var ownerState = param.ownerState;
                    return ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'rectangular';
                },
                style: _define_property({
                    top: 0,
                    left: 0,
                    transform: 'scale(1) translate(-50%, -50%)',
                    transformOrigin: '0% 0%'
                }, "&.".concat(badgeClasses.invisible), {
                    transform: 'scale(0) translate(-50%, -50%)'
                })
            },
            {
                props: function(param) {
                    var ownerState = param.ownerState;
                    return ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'rectangular';
                },
                style: _define_property({
                    bottom: 0,
                    left: 0,
                    transform: 'scale(1) translate(-50%, 50%)',
                    transformOrigin: '0% 100%'
                }, "&.".concat(badgeClasses.invisible), {
                    transform: 'scale(0) translate(-50%, 50%)'
                })
            },
            {
                props: function(param) {
                    var ownerState = param.ownerState;
                    return ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'circular';
                },
                style: _define_property({
                    top: '14%',
                    right: '14%',
                    transform: 'scale(1) translate(50%, -50%)',
                    transformOrigin: '100% 0%'
                }, "&.".concat(badgeClasses.invisible), {
                    transform: 'scale(0) translate(50%, -50%)'
                })
            },
            {
                props: function(param) {
                    var ownerState = param.ownerState;
                    return ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'circular';
                },
                style: _define_property({
                    bottom: '14%',
                    right: '14%',
                    transform: 'scale(1) translate(50%, 50%)',
                    transformOrigin: '100% 100%'
                }, "&.".concat(badgeClasses.invisible), {
                    transform: 'scale(0) translate(50%, 50%)'
                })
            },
            {
                props: function(param) {
                    var ownerState = param.ownerState;
                    return ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'circular';
                },
                style: _define_property({
                    top: '14%',
                    left: '14%',
                    transform: 'scale(1) translate(-50%, -50%)',
                    transformOrigin: '0% 0%'
                }, "&.".concat(badgeClasses.invisible), {
                    transform: 'scale(0) translate(-50%, -50%)'
                })
            },
            {
                props: function(param) {
                    var ownerState = param.ownerState;
                    return ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'circular';
                },
                style: _define_property({
                    bottom: '14%',
                    left: '14%',
                    transform: 'scale(1) translate(-50%, 50%)',
                    transformOrigin: '0% 100%'
                }, "&.".concat(badgeClasses.invisible), {
                    transform: 'scale(0) translate(-50%, 50%)'
                })
            },
            {
                props: {
                    invisible: true
                },
                style: {
                    transition: theme.transitions.create('transform', {
                        easing: theme.transitions.easing.easeInOut,
                        duration: theme.transitions.duration.leavingScreen
                    })
                }
            }
        ])
    };
}));
function getAnchorOrigin(anchorOrigin) {
    var _anchorOrigin_vertical, _anchorOrigin_horizontal;
    return {
        vertical: (_anchorOrigin_vertical = anchorOrigin === null || anchorOrigin === void 0 ? void 0 : anchorOrigin.vertical) !== null && _anchorOrigin_vertical !== void 0 ? _anchorOrigin_vertical : 'top',
        horizontal: (_anchorOrigin_horizontal = anchorOrigin === null || anchorOrigin === void 0 ? void 0 : anchorOrigin.horizontal) !== null && _anchorOrigin_horizontal !== void 0 ? _anchorOrigin_horizontal : 'right'
    };
}
var Badge = /*#__PURE__*/ React.forwardRef(function Badge(inProps, ref) {
    var props = useDefaultProps({
        props: inProps,
        name: 'MuiBadge'
    });
    var anchorOriginProp = props.anchorOrigin, className = props.className, classesProp = props.classes, component = props.component, _props_components = props.components, components = _props_components === void 0 ? {} : _props_components, _props_componentsProps = props.componentsProps, componentsProps = _props_componentsProps === void 0 ? {} : _props_componentsProps, children = props.children, tmp = props.overlap, overlapProp = tmp === void 0 ? 'rectangular' : tmp, tmp1 = props.color, colorProp = tmp1 === void 0 ? 'default' : tmp1, tmp2 = props.invisible, invisibleProp = tmp2 === void 0 ? false : tmp2, tmp3 = props.max, maxProp = tmp3 === void 0 ? 99 : tmp3, badgeContentProp = props.badgeContent, slots = props.slots, slotProps = props.slotProps, _props_showZero = props.showZero, showZero = _props_showZero === void 0 ? false : _props_showZero, tmp4 = props.variant, variantProp = tmp4 === void 0 ? 'standard' : tmp4, other = _object_without_properties(props, [
        "anchorOrigin",
        "className",
        "classes",
        "component",
        "components",
        "componentsProps",
        "children",
        "overlap",
        "color",
        "invisible",
        "max",
        "badgeContent",
        "slots",
        "slotProps",
        "showZero",
        "variant"
    ]);
    var _useBadge = useBadge({
        max: maxProp,
        invisible: invisibleProp,
        badgeContent: badgeContentProp,
        showZero: showZero
    }), badgeContent = _useBadge.badgeContent, invisibleFromHook = _useBadge.invisible, max = _useBadge.max, displayValueFromHook = _useBadge.displayValue;
    var prevProps = usePreviousProps({
        anchorOrigin: getAnchorOrigin(anchorOriginProp),
        color: colorProp,
        overlap: overlapProp,
        variant: variantProp,
        badgeContent: badgeContentProp
    });
    var invisible = invisibleFromHook || badgeContent == null && variantProp !== 'dot';
    var _ref = invisible ? prevProps : props, _ref_color = _ref.color, color = _ref_color === void 0 ? colorProp : _ref_color, _ref_overlap = _ref.overlap, overlap = _ref_overlap === void 0 ? overlapProp : _ref_overlap, anchorOriginPropProp = _ref.anchorOrigin, _ref_variant = _ref.variant, variant = _ref_variant === void 0 ? variantProp : _ref_variant;
    var anchorOrigin = getAnchorOrigin(anchorOriginPropProp);
    var displayValue = variant !== 'dot' ? displayValueFromHook : undefined;
    var ownerState = _object_spread_props(_object_spread({}, props), {
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue,
        showZero: showZero,
        anchorOrigin: anchorOrigin,
        color: color,
        overlap: overlap,
        variant: variant
    });
    var classes = useUtilityClasses(ownerState);
    var _slots_root, _ref1;
    // support both `slots` and `components` for backward compatibility
    var RootSlot = (_ref1 = (_slots_root = slots === null || slots === void 0 ? void 0 : slots.root) !== null && _slots_root !== void 0 ? _slots_root : components.Root) !== null && _ref1 !== void 0 ? _ref1 : BadgeRoot;
    var _slots_badge, _ref2;
    var BadgeSlot = (_ref2 = (_slots_badge = slots === null || slots === void 0 ? void 0 : slots.badge) !== null && _slots_badge !== void 0 ? _slots_badge : components.Badge) !== null && _ref2 !== void 0 ? _ref2 : BadgeBadge;
    var _slotProps_root;
    var rootSlotProps = (_slotProps_root = slotProps === null || slotProps === void 0 ? void 0 : slotProps.root) !== null && _slotProps_root !== void 0 ? _slotProps_root : componentsProps.root;
    var _slotProps_badge;
    var badgeSlotProps = (_slotProps_badge = slotProps === null || slotProps === void 0 ? void 0 : slotProps.badge) !== null && _slotProps_badge !== void 0 ? _slotProps_badge : componentsProps.badge;
    var rootProps = useSlotProps({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: clsx(rootSlotProps === null || rootSlotProps === void 0 ? void 0 : rootSlotProps.className, classes.root, className)
    });
    var badgeProps = useSlotProps({
        elementType: BadgeSlot,
        externalSlotProps: badgeSlotProps,
        ownerState: ownerState,
        className: clsx(classes.badge, badgeSlotProps === null || badgeSlotProps === void 0 ? void 0 : badgeSlotProps.className)
    });
    return /*#__PURE__*/ _jsxs(RootSlot, _object_spread_props(_object_spread({}, rootProps), {
        children: [
            children,
            /*#__PURE__*/ _jsx(BadgeSlot, _object_spread_props(_object_spread({}, badgeProps), {
                children: displayValue
            }))
        ]
    }));
});
process.env.NODE_ENV !== "production" ? Badge.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The anchor of the badge.
   * @default {
   *   vertical: 'top',
   *   horizontal: 'right',
   * }
   */ anchorOrigin: PropTypes.shape({
        horizontal: PropTypes.oneOf([
            'left',
            'right'
        ]),
        vertical: PropTypes.oneOf([
            'bottom',
            'top'
        ])
    }),
    /**
   * The content rendered within the badge.
   */ badgeContent: PropTypes.node,
    /**
   * The badge will be added relative to this node.
   */ children: PropTypes.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: PropTypes.object,
    /**
   * @ignore
   */ className: PropTypes.string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */ color: PropTypes /* @typescript-to-proptypes-ignore */ .oneOfType([
        PropTypes.oneOf([
            'default',
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        PropTypes.string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: PropTypes.elementType,
    /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */ components: PropTypes.shape({
        Badge: PropTypes.elementType,
        Root: PropTypes.elementType
    }),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */ componentsProps: PropTypes.shape({
        badge: PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.object
        ]),
        root: PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.object
        ])
    }),
    /**
   * If `true`, the badge is invisible.
   * @default false
   */ invisible: PropTypes.bool,
    /**
   * Max count to show.
   * @default 99
   */ max: PropTypes.number,
    /**
   * Wrapped shape the badge should overlap.
   * @default 'rectangular'
   */ overlap: PropTypes.oneOf([
        'circular',
        'rectangular'
    ]),
    /**
   * Controls whether the badge is hidden when `badgeContent` is zero.
   * @default false
   */ showZero: PropTypes.bool,
    /**
   * The props used for each slot inside the Badge.
   * @default {}
   */ slotProps: PropTypes.shape({
        badge: PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.object
        ]),
        root: PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.object
        ])
    }),
    /**
   * The components used for each slot inside the Badge.
   * Either a string to use a HTML element or a component.
   * @default {}
   */ slots: PropTypes.shape({
        badge: PropTypes.elementType,
        root: PropTypes.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.object,
            PropTypes.bool
        ])),
        PropTypes.func,
        PropTypes.object
    ]),
    /**
   * The variant to use.
   * @default 'standard'
   */ variant: PropTypes /* @typescript-to-proptypes-ignore */ .oneOfType([
        PropTypes.oneOf([
            'dot',
            'standard'
        ]),
        PropTypes.string
    ])
} : void 0;
export default Badge;
